import { FastViewBook } from 'Lib/fast-view-book/fast-view-book';
import { isLocalhost } from 'Lib/is-localhost/is-localhost';
import { oLike } from 'Lib/like/like';
import { eksmoBP } from 'Lib/bp/bp';
import { getW } from 'Lib/w/w';
import { isTouch } from 'Lib/istouch/istouch';
import { isNoEmptyString } from 'Lib/is-no-empty-string/is-no-empty-string';
import { CheckboxAccept } from 'Lib/checkbox-accept/checkbox-accept';
import { eventSender } from 'Lib/event-sender/event-sender';

export class FastViewBookShowNotPopup extends FastViewBook {
    constructor(nomcode = null) {
        super(nomcode);
    }

    show(elInsert, sTab, withMobile) {
        if (withMobile || (getW() > eksmoBP.smMax && !isTouch() && isNoEmptyString(this._nomcode))) {
            const sBookPage = '.book-page_fast-view';

            $.ajax({
                type: 'POST',
                url: isLocalhost() ? `/eksmo/_verstka/ajax/book-fast-view.php?NC=${this._nomcode}` : `/ajax/book/fast-view/?NC=${this._nomcode}`,
                success: (data) => {
                    this._loadResources(() => {
                        elInsert.html(data);

                        if (typeof sTab === 'string') {
                            this._$body.trigger('switchTab.tabs.eksmo', [$(sTab)]);
                        }

                        this._$body.trigger('init.tabs.eksmo');
                        oLike.init(`${sBookPage} .js-like`);
                        this._$body.trigger('init.fastViewBook');

                        document.querySelectorAll('.mail-form__form').forEach((item) => {
                            const checkboxes = new CheckboxAccept(
                                'subscription',
                                '.mail-form__form',
                                '.checkbox input',
                                '.checkbox__content-offset',
                                '.mail-form__btn',
                                item,
                            );

                            checkboxes.setEventCheckboxAccept();
                        });

                        eventSender.setViewBookMD();

                        if (typeof setupButtonAddToBasket === 'function') {
                            setupButtonAddToBasket(window.settingsWl);
                        }
                    });
                },
            });
        }
    }
}